module.exports = __webpack_public_path__ + "static/door-flowers-9c0af17af06f3f4eea48b338dc1ce408.jpg";